import './MarketReport.scss';
import Component from './MarketReport.js';
export default Component;
